/* eslint-disable jsx-a11y/anchor-is-valid */
/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Link, Menu, MenuItem } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import { useState } from 'react';
import { consoleCommands } from 'modules/common/ui-controller';
import { splitCommandUrl } from 'modules/common/ui-controller/utils/functions';
import { ENVIRONMENT } from 'config';
import { useLocation } from 'react-router-dom';

const ShareableUrl = ({ msg, responseId, page }) => {
  const location = useLocation();
  const domain =
    window.location.origin === ENVIRONMENT.APP_URL ? ENVIRONMENT.APP_URL : ENVIRONMENT.AIRO_APP_URL;

  const [contextMenu, setContextMenu] = useState(null);

  // Url of the record, it opens the drawer with this response expanded for the user who owns it
  const getRecordUrl = () => {
    const { search, hash } = splitCommandUrl(msg?.url);
    let url = `${domain}${location?.pathname}?${search}`;
    if (responseId) {
      url += `&${consoleCommands.VI_HISTORY}=${encodeURIComponent(responseId)}`;
      if (page) url += `&${consoleCommands.VI_HISTORY_PAGE}=${page}`;
    }
    return hash ? `${url}#${hash}` : url;
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 } : null
    );
  };

  const handleClose = () => {
    setContextMenu(null);
  };

  const handleCopy = (event) => {
    event.stopPropagation();
    if (msg?.url) {
      navigator.clipboard.writeText(getRecordUrl());
    }
    handleClose();
  };

  const getTruncatedText = (str = '') => `${str?.slice(0, 22)} ...` ?? '';

  return (
    <div
      onContextMenu={handleContextMenu}
      style={{ cursor: 'context-menu', display: 'flex', minWidth: 0, maxWidth: '100%' }}
    >
      <Link
        href="#"
        component="button"
        onClick={(event) => {
          event.stopPropagation();
          if (!msg?.url) return;
          window.open(getRecordUrl(), '_blank', 'noopener,noreferrer');
        }}
        sx={{
          display: 'inline-flex',
          minWidth: 0,
          alignItems: 'center',
          verticalAlign: 'middle',
          ml: 0.5,
          textDecoration: 'underline',
          color: '#1976d2',
          whiteSpace: 'nowrap',
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        <LinkIcon sx={{ fontSize: '1.2rem', mr: 0.5, flexShrink: 0 }} />
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {getTruncatedText(msg?.url)}
        </span>
      </Link>
      <Menu
        open={contextMenu !== null}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined
        }
      >
        <MenuItem sx={{ fontSize: '0.8rem', minHeight: 'auto' }} onClick={handleCopy}>
          Copy Link
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ShareableUrl;
